var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.935 10.6128L7.93458 4.95366L13.3379 7.79283L7.935 10.6128ZM19.8 3.97283C19.8 3.97283 19.6042 2.58533 19.005 1.97366C18.2446 1.17116 17.3917 1.16741 17.0012 1.12116C14.2025 0.916992 10.0042 0.916992 10.0042 0.916992H9.99583C9.99583 0.916992 5.7975 0.916992 2.99875 1.12116C2.6075 1.16699 1.75542 1.17116 0.994583 1.97324C0.394583 2.58491 0.2 3.97283 0.2 3.97283C0.2 3.97283 0 5.60324 0 7.23283V8.76116C0 10.3912 0.2 12.0207 0.2 12.0207C0.2 12.0207 0.395 13.4087 0.994167 14.0199C1.75542 14.8224 2.755 14.7974 3.2 14.8812C4.8 15.0357 10 15.0837 10 15.0837C10 15.0837 14.2025 15.0774 17.0012 14.8732C17.3921 14.8262 18.2446 14.8224 19.005 14.0199C19.6046 13.4087 19.8 12.0207 19.8 12.0207C19.8 12.0207 20 10.3916 20 8.76116V7.23283C20 5.60324 19.8 3.97283 19.8 3.97283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7a8bcb3aebb83b00a27ed8e6827705ea.svg";
export { ForwardRef as ReactComponent };